// extracted by mini-css-extract-plugin
module.exports = {"register-success":"ManualDocumentsValidation_register-success__CcwUS","icon-big":"ManualDocumentsValidation_icon-big__syYTD","text":"ManualDocumentsValidation_text__2PHZY"};